import type { ColumnDef } from "@tanstack/react-table";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import type { FieldData } from "~/components/ui/itemModal/types";
import FieldTable from "../fieldTable";
import styles from "./index.module.scss";

interface FieldTabsComponentProps {
  tabTitles: string[];
  dataSets: FieldData[][];
  columns: Array<ColumnDef<FieldData>[]>;
  updateData: (
    rowIndex: number,
    columnId: string,
    value: string | number,
    tabIndex: number,
  ) => void;
  isEditable: boolean;
  onTabChange: (tabIndex: number) => void; // タブ変更のコールバック
  onReorder?: (newData: FieldData[], tabIndex: number) => void;
  tableMeta?: Record<string, unknown>;
}

const FieldDesignTabs = ({
  dataSets,
  columns,
  tabTitles,
  updateData,
  isEditable,
  onTabChange,
  onReorder,
  tableMeta,
}: FieldTabsComponentProps) => {
  const handleTabClick = (index: number) => {
    onTabChange(index); // 親にタブ変更を通知
  };
  return (
    <Tabs className={styles["tab"]}>
      <TabList className={styles["tab-list"]}>
        {tabTitles.map((title, index) => (
          <Tab
            key={index}
            className={styles["tab-list-name"]}
            selectedClassName={styles["tab-list-name--selected"]}
            onClick={() => handleTabClick(index)}
          >
            {title}
          </Tab>
        ))}
      </TabList>

      {dataSets.map((dataSet, index) => (
        <TabPanel key={index} className={styles["custom-tab-panel"]}>
          <FieldTable
            data={dataSet}
            columns={columns[index] || []}
            updateData={(rowIndex, columnId, value) =>
              updateData(rowIndex, String(columnId), value, index)
            }
            isEditable={isEditable}
            {...(tableMeta && { tableMeta })}
            {...(onReorder && { onReorder: (newData) => onReorder(newData, index) })}
          />
        </TabPanel>
      ))}
    </Tabs>
  );
};

export default FieldDesignTabs;
